import { render, staticRenderFns } from "./ContactStoreForm.vue?vue&type=template&id=66ff67ff&scoped=true&"
import script from "./ContactStoreForm.vue?vue&type=script&lang=js&"
export * from "./ContactStoreForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactStoreForm.vue?vue&type=style&index=0&id=66ff67ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff67ff",
  null
  
)

export default component.exports